"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.simplify = void 0;
/**
 * Turns all optional values in an object to the value itself if it is truthy, or undefined if not.
 * @param obj The object to simplify.
 */
function simplify(obj) {
    var except = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        except[_i - 1] = arguments[_i];
    }
    var ret = {};
    // tslint:disable-next-line: forin
    for (var key in obj) {
        if (except.includes && except.includes(key)) {
            continue;
        }
        ret[key] = obj[key] || undefined;
    }
    return ret;
}
exports.simplify = simplify;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/helpers/Functions/Simplify.js
// module id = 205
// module chunks = 8